import { styled } from "@mui/material";
import AnalysisLine from "./AnalysisLine";

const ContainerStyled = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
});

const Analysis = ({ isEn, isEditMode, analysis, setAnalysis }) => {
  const handleChange = (elementKey, newElement) => {
    setAnalysis((prev) => ({
      ...prev,
      [elementKey]: newElement,
    }));
  };

  return (
    <ContainerStyled>
      {Object.entries(analysis).map(([key, value]) => (
        <AnalysisLine
          isEditMode={isEditMode}
          isEn={isEn}
          elementKey={key}
          element={value}
          onChange={handleChange}
        />
      ))}
    </ContainerStyled>
  );
};
export default Analysis;
